import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Link as GatsbyLink } from 'gatsby'

const Link = ({ children, className, type, ...props }) => {
  return (
    <GatsbyLink activeClassName="is-active" className={classnames(className, type)} {...props}>
      {children}
    </GatsbyLink>
  )
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button']),
  props: PropTypes.object,
}

export { Link }
